import { useMemo, useState } from 'react'
import { Spotlight, SpotlightInput, SpotlightClear, SpotlightResults, SpotlightSection, SpotlightItem, SpotlightHit, SpotlightEmpty } from '@ofself/shell'

/* FINDING IS THE RAIL'S JOB (owner call 2026-09-18: the head is icons, no
   search band). The rail's own SEARCH seat opens the kit's <Spotlight>, as
   ink's does: one field over the words, name first and definition second,
   the way looking a word up actually goes. ⌘K reaches it too; Esc and a pick
   close it, and ↑↓ and Return are the kit's. */
export default function Find({ open, onClose, words, current, onPick }) {
  const [q, setQ] = useState('')
  // every opening starts clean, in the very render that opens it (ink's rule)
  const [wasOpen, setWasOpen] = useState(open)
  if (wasOpen !== open) { setWasOpen(open); if (open) setQ('') }

  const needle = q.trim().toLowerCase()
  const hits = useMemo(() => {
    if (!needle) return words.slice(0, 12)
    // a name match outranks a definition match; an exact head outranks both
    const score = w => {
      const name = w.name.toLowerCase()
      if (name === needle) return 4
      if (name.startsWith(needle)) return 3
      if (name.includes(needle) || (w.aliases || []).some(a => a.toLowerCase().includes(needle)) || (w.synonyms || []).some(r => r.term.toLowerCase().includes(needle))) return 2
      if ((w.text || '').toLowerCase().includes(needle)) return 1
      return 0
    }
    return words.map(w => [w, score(w)]).filter(([, s]) => s > 0)
      .sort((a, b) => b[1] - a[1] || a[0].name.localeCompare(b[0].name)).slice(0, 12).map(([w]) => w)
  }, [needle, words])

  // the name with the needle marked, as the kit's hit marks it
  const parts = name => {
    const at = needle ? name.toLowerCase().indexOf(needle) : -1
    return at < 0 ? name : [{ text: name.slice(0, at) }, { text: name.slice(at, at + needle.length), hit: true }, { text: name.slice(at + needle.length) }]
  }
  // a friend's word says whose it is: a find over shared words would
  // otherwise show two 'tidepool's and no way to tell them apart
  const by = w => w.owner && (w.owner.username || w.owner.display_name)
  const pick = id => { onClose(); onPick(id) }

  return <Spotlight open={open} onClose={onClose} label="Find a word">
    <SpotlightInput value={q} onChange={e => setQ(e.target.value)} placeholder="Find a word…"
      after={q && <SpotlightClear onClick={() => setQ('')} />} />
    <SpotlightResults>
      {hits.length
        ? <SpotlightSection key={needle ? 'hits' : 'all'} title={`${hits.length} ${hits.length === 1 ? 'word' : 'words'}`}>
            {hits.map(w => <SpotlightItem key={w.id} current={w.id === current} onClick={() => pick(w.id)}>
              <SpotlightHit title={parts(w.name || 'Untitled')} tags={[by(w)]} snippet={w.text} />
            </SpotlightItem>)}
          </SpotlightSection>
        : <SpotlightEmpty>{needle ? `No word matches “${q.trim()}”` : 'No words yet'}</SpotlightEmpty>}
    </SpotlightResults>
  </Spotlight>
}
